/* tslint:disable */
/* eslint-disable */
/**
 * back-office-service
 * Back Office Service
 *
 * The version of the OpenAPI document: 0.27.49
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Response from creating a search collection. Includes the freshly minted analytics key in encoded
 * form. The encoded key is returned only once at creation time and cannot be retrieved later — the
 * caller must save it before the response is discarded.
 * @export
 * @interface CreateSearchConfigResponse
 */
export interface CreateSearchConfigResponse {
    /**
     * 
     * @type {string}
     * @memberof CreateSearchConfigResponse
     */
    encodedAnalyticsKey: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateSearchConfigResponse
     */
    noResultsMessages: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateSearchConfigResponse
     */
    hosts: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof CreateSearchConfigResponse
     */
    loadBalancedEndpoint: string;
    /**
     * 
     * @type {string}
     * @memberof CreateSearchConfigResponse
     */
    hostname: string;
    /**
     * 
     * @type {string}
     * @memberof CreateSearchConfigResponse
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof CreateSearchConfigResponse
     */
    id: string;
}

/**
 * Check if a given object implements the CreateSearchConfigResponse interface.
 */
export function instanceOfCreateSearchConfigResponse(value: object): value is CreateSearchConfigResponse {
    if (!('encodedAnalyticsKey' in value) || value['encodedAnalyticsKey'] === undefined) return false;
    if (!('noResultsMessages' in value) || value['noResultsMessages'] === undefined) return false;
    if (!('hosts' in value) || value['hosts'] === undefined) return false;
    if (!('loadBalancedEndpoint' in value) || value['loadBalancedEndpoint'] === undefined) return false;
    if (!('hostname' in value) || value['hostname'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('id' in value) || value['id'] === undefined) return false;
    return true;
}

export function CreateSearchConfigResponseFromJSON(json: any): CreateSearchConfigResponse {
    return CreateSearchConfigResponseFromJSONTyped(json, false);
}

export function CreateSearchConfigResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateSearchConfigResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'encodedAnalyticsKey': json['encodedAnalyticsKey'],
        'noResultsMessages': json['noResultsMessages'],
        'hosts': json['hosts'],
        'loadBalancedEndpoint': json['loadBalancedEndpoint'],
        'hostname': json['hostname'],
        'name': json['name'],
        'id': json['id'],
    };
}

export function CreateSearchConfigResponseToJSON(value?: CreateSearchConfigResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'encodedAnalyticsKey': value['encodedAnalyticsKey'],
        'noResultsMessages': value['noResultsMessages'],
        'hosts': value['hosts'],
        'loadBalancedEndpoint': value['loadBalancedEndpoint'],
        'hostname': value['hostname'],
        'name': value['name'],
        'id': value['id'],
    };
}

